<template>
  <div
    class="flex flex-col absolute bottom-0 rounded-[12px] border border-[#F3F3F3] bg-white"
    :style="{ left: isMinimized ? '60px' : '270px' }"
  >
    <div
      class="flex w-[448px] p-[14px_16px] items-center gap-[14px] border-b border-[#F3F3F3]"
    >
      <i
        :class="[`mdi mdi-bell min-w-6  text-xl text-primary`]"
        @dblclick="bellDblClick"
      ></i>
      <NuxtLink to="/notifications"
        ><div
          class="text-[#151515] text-lg font-semibold leading-[28px] font-['Noto_Sans']"
          @click="emit('close')"
        >
          Notifications ({{ notificationStore.count }})
        </div>
      </NuxtLink>

      <i
        :class="[
          `mdi mdi-close min-w-6  text-xl text-primary ml-auto cursor-pointer`,
        ]"
        @click="emit('close')"
      ></i>
    </div>
    <TailwindComponentsLoading medium class="m-8" v-if="isLoading" />
    <div v-else>
      <ul
        v-if="notifications.length > 0"
        class="divide-y divide-gray-100 overflow-auto max-h-[400px]"
      >
        <li :class="['flex flex-col']" v-for="n in notifications">
          <div
            :class="{
              'opacity-60': n.isRead,
              'cursor-pointer': !n.isRead,
              flex: true,
            }"
          >
            <BaseNotificationItem
              :type="n.type"
              :payload="n.payload"
              @delete="deleteNotification(n.id)"
              @wasRead="checkRead(n)"
            />
            <div
              class="ml-auto flex p-[14px_16px] items-start gap-[14px] self-stretch"
            >
              <i v-if="!n.isRead" class="mdi mdi-circle text-[10px]"></i>
            </div>
          </div>
        </li>
      </ul>
      <div class="p-4" v-else>There are currently no notifications.</div>
      <div
        v-if="notifications.length > 0"
        class="flex w-[448px] p-4 justify-center items-center border-t border-[#F3F3F3]"
        @click="markAllAsRead()"
      >
        <div class="flex h-5 justify-center items-center gap-2 cursor-pointer">
          <i :class="[`mdi mdi-check-all text-xl text-primary`]"></i>
          <div
            class="text-[#193060] font-[600] text-base leading-6 font-['Noto_Sans']"
          >
            Mark all as read
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  isMinimized: boolean
}>()

const emit = defineEmits(['close'])
const notifications = ref<any>([])
const notificationsApi = useNotifications()
const notificationStore = useNotificationsStore()
const isLoading = ref<boolean>(false)
const { userProfile } = useKeycloak()

onMounted(async () => {
  isLoading.value = true
  await getNotifications()
  await nextTick()
  isLoading.value = false
})

watch(
  () => notificationStore.count,
  () => {
    getNotifications()
  }
)

const bellDblClick = async () => {
  await notificationsApi.testNotification()
}

const deleteNotification = async (notificationId: number) => {
  await notificationsApi.deleteNotification({
    id: notificationId,
  })
  notifications.value = notifications.value.filter((notification: any) => {
    return notification.id !== notificationId
  })
}

const checkRead = async (notification: any) => {
  if (notification.isRead) return
  markAsRead(notification.id)
}

const markAsRead = async (notificationId: number) => {
  const response = await notificationsApi.markAsRead({
    id: notificationId,
  })
  notifications.value = notifications.value.map((notification: any) => {
    if (notification.id === notificationId) {
      return response
    }
    return notification
  })
}

const markAllAsRead = async () => {
  const unreadIds = notifications.value
    .filter((notification: any) => !notification.isRead)
    .map((notification: any) => notification.id)
  const promises = unreadIds.map(id => notificationsApi.markAsRead({ id }))
  await Promise.all(promises)
  await getNotifications()
}

const getNotifications = async () => {
  notifications.value =
    (await notificationsApi.getAllNotifications({ limit: 100, offset: 0 })) ||
    []
}
</script>

<style></style>
